import { Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';

import { ROUTES } from '../constants/routes';
import { useAuth } from '../store/authStore';
import LoginPage from '../pages/LoginPage';
import OverviewPage from '../pages/OverviewPage';
import QueuesPage from '../pages/QueuesPage';
import ProductsPage from '../pages/ProductsPage';
import SubscriptionsPage from '../pages/SubscriptionsPage';
import UsersPage from '../pages/UsersPage';
import SecurityPage from '../pages/SecurityPage';
import CooldownAccountsPage from '../pages/CooldownAccountsPage';
import IpBlocksPage from '../pages/IpBlocksPage';
import { ProtectedRoute } from './ProtectedRoute';

function RootRoute() {
  const { user, isLoading } = useAuth();
  if (isLoading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0f0f12' }}>
      <div style={{ width: 40, height: 40, borderRadius: '50%', border: '3px solid #333', borderTopColor: '#6c63ff', animation: 'spin 0.7s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
  return <Navigate to={user ? ROUTES.OVERVIEW : ROUTES.LOGIN} replace />;
}

export function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<RootRoute />} />
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.OVERVIEW} element={<ProtectedRoute><OverviewPage /></ProtectedRoute>} />
        <Route path={ROUTES.QUEUES} element={<ProtectedRoute><QueuesPage /></ProtectedRoute>} />
        <Route path={ROUTES.USERS} element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
        <Route path={ROUTES.PRODUCTS} element={<ProtectedRoute><ProductsPage /></ProtectedRoute>} />
        <Route path={ROUTES.SUBSCRIPTIONS} element={<ProtectedRoute><SubscriptionsPage /></ProtectedRoute>} />
        <Route path={ROUTES.SECURITY} element={<ProtectedRoute><SecurityPage /></ProtectedRoute>} />
        <Route path={ROUTES.COOLDOWN_ACCOUNTS} element={<ProtectedRoute><CooldownAccountsPage /></ProtectedRoute>} />
        <Route path={ROUTES.IP_BLOCKS} element={<ProtectedRoute><IpBlocksPage /></ProtectedRoute>} />
      </Routes>
      <Toaster theme="dark" richColors />
    </>
  );
}
